import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14" aria-labelledby="testimonios" data-id="element-245" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto w-full max-w-3xl" data-id="element-246" data-mp="3r7intd74my1f">
        <h2 id="testimonios" className="text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-247" data-mp="3r8amiww0tbvx">
          Lo que dicen los médicos que ya usan Ruta Hipertensión
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-248" data-mp="44vzee5lvj27">
          Más de 2.000 médicos ya transformaron la forma en que manejan a sus
          pacientes hipertensos. Ellos no compraron un PDF: compraron una forma más
          rápida, organizada y segura de decidir.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-249" data-mp="2fs3r8aity86u">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-3xl border border-navy/10 bg-cream p-5" data-id="element-250" data-mp="1sl2mtv373s01">
              <QuoteIcon className="h-6 w-6 text-brandred/40" aria-hidden="true" data-id="element-251" data-mp="1nrq1puxq63c1" />
              <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-navy/80" data-id="element-252" data-mp="1ete7lixngneu">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-4 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-253" data-mp="2bilw8ztkfcmz">
                <img src={testimonial.image} alt={testimonial.name} className="h-12 w-12 shrink-0 rounded-full object-cover" data-id="element-254" data-mp="26ktyhp68owav" />
                <figcaption className="min-w-0" data-id="element-255" data-mp="1xj42e61ex96r">
                  <p className="truncate text-sm font-extrabold text-navy" data-id="element-256" data-mp="r3a4rdsacrow">
                    {testimonial.name}
                  </p>
                  <p className="truncate text-xs text-navy/60" data-id="element-257" data-mp="m3nwzjv883nh">
                    {testimonial.role}
                  </p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-258" data-mp="njjhukr91c4s">
                    {Array.from({
                  length: 5
                }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-brandred text-brandred" aria-hidden="true" data-id="element-259" data-mp="elpn3e94uqjq" data-mpi={index} />)}
                  </div>
                </figcaption>
              </div>
            </figure>)}
        </div>

        <div className="mt-8" data-id="element-260" data-mp="9nxxwrzvhij8">
          <CTAButton label="Quiero los mismos resultados" data-id="element-261" data-mp="3r2uyad173dfu" />
        </div>
      </div>
    </section>;
}